import { watch } from 'vue';

export const useBeforeUnloadGuard = shouldBlock => {
  const blockUnload = event => {
    event.preventDefault();
    event.returnValue = true;
  };

  watch(
    shouldBlock,
    (blocked, _previous, onCleanup) => {
      if (!blocked) return;
      window.addEventListener('beforeunload', blockUnload);
      onCleanup(() => window.removeEventListener('beforeunload', blockUnload));
    },
    { immediate: true, flush: 'sync' }
  );
};
